<!--
 * @Description: 
 * @Version: 2.0
 * @Author: 王有毒
 * @Date: 2023-03-24 11:44:37
 * @LastEditors: 王有毒
 * @LastEditTime: 2023-08-11 15:42:08
 * @FilePath: \edub_tob_pc\src\components\cutdownPublic.vue
-->
<template>
  <div class="cutDown">
    <!-- <div class="time">{{ day }}</div>
    <span>天</span> -->
    <div class="time">{{ hour < 0 ? 0 : hour }}</div>
        <span>:</span>
        <div class="time">{{ minute < 0 ? 0 : minute }}</div>
            <span>:</span>
            <div class="time">{{ second < 0 ? 0 : second }}</div>
            </div>
</template>

<script>
export default {
  data() {
    return {
      day: 0,
      hour: 0,
      minute: 0,
      second: 0,
      nowTime: +new Date(),
      cutDown: null
    }
  },
  props: ['startTime'],
  created() {
    // 创建定时器
    this.cutDown = setInterval(() => {
      const t = +new Date(this.startTime) - +new Date()
      // this.day = Math.floor(t / 86400000)
      this.hour = Math.floor(t / 3600000)
      this.minute = Math.floor((t / 60000) % 60)
      this.second = Math.floor((t / 1000) % 60)
      if (this.hour <= 0 && this.minute <= 0 && this.second <= 0) {
        this.$emit("isOk");
      }
    }, 1000)
  },
  destroyed() {
    clearInterval(this.cutDown)
    this.cutDown = null
  }
}
</script>

<style lang="less" scoped>
.cutDown {
  display: flex;
  align-items: center;
  font-size: 18px;
  font-family: PingFang SC-Bold, PingFang SC;
  font-weight: bold;
  color: #dddddd;

  span {
    margin: 0 10px;
  }

  .time {
    width: 36px;
    height: 35px;
    background: #fce4e4;
    border-radius: 4px 4px 4px 4px;
    opacity: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 19px;
    font-family: PingFang SC-Bold, PingFang SC;
    font-weight: bold;
    color: #f8343e;
  }
}
</style>
